export type FeatureType = 'outer' | 'inner' | 'solid' | 'infill' | 'support' | 'brim';

export const FEATURE_TYPES: FeatureType[] = ['outer', 'inner', 'solid', 'infill', 'support', 'brim'];

export const FEATURE_COLORS: Record<FeatureType, number> = {
  outer: 0xe23b2c,
  inner: 0x22a35a,
  solid: 0xf2d000,
  infill: 0xf0a020,
  support: 0x22b8cf,
  brim: 0x9aa0a6,
};

export const FEATURE_LABELS: Record<FeatureType, string> = {
  outer: 'Outer wall',
  inner: 'Inner wall',
  solid: 'Top / bottom',
  infill: 'Infill',
  support: 'Support',
  brim: 'Skirt / brim',
};

export interface SliceObjectInput {
  id: string;
  positions: Float32Array;
  position: [number, number, number];
  rotation: [number, number, number];
  scale: [number, number, number];
  overrides: Record<string, string | number | boolean>;
  paintSupports?: Uint8Array;
}

export interface SliceRequest {
  requestId: number;
  objects: SliceObjectInput[];
  settings: Record<string, string | number | boolean>;
}

export interface PackedLayer {
  index: number;
  z: number;
  height: number;
  /** Packed 2D polylines per feature: x,y pairs, NaN,NaN separators */
  paths: Partial<Record<FeatureType, Float32Array>>;
  lengths: Partial<Record<FeatureType, number>>;
}

export interface SliceEstimate {
  approxMinutes: number;
  filamentGrams: number;
  filamentMetres: number;
  pathMm: number;
  note: string;
}

export interface SliceProgress {
  type: 'progress';
  requestId: number;
  pct: number;
  message: string;
  layer?: PackedLayer;
}

export interface SliceDone {
  type: 'done';
  requestId: number;
  layers: PackedLayer[];
  estimate: SliceEstimate;
  elapsedMs: number;
  triangleCount: number;
  segmentCount: number;
  layerCount: number;
  capped: boolean;
}

export interface SliceError {
  type: 'error';
  requestId: number;
  message: string;
}

export type SliceWorkerMsg = SliceProgress | SliceDone | SliceError;
